import axios from "axios";
import moment from "moment";
import React, { useState } from "react";
import { Calendar } from "react-multi-date-picker";
import AllDataHeader from "../../../../../Reuseable/AllDataHeader";
import NewSchedule from "../NewSchedule";
import "./EventScheduleDatePick.css";

const EventScheduleDatePick = () => {
  const [selectElement, setSelectElement] = useState(0);
  const [dates, setDates] = useState([]);
  const [newSchedule, setNewSchedule] = useState([]);
  const [schedule, setSchedule] = useState({});
  const [createForm, setCreateForm] = useState(false);
  const [selectedSchedule, setSelectedSchedule] = useState([]);
  const [pending, setPending] = useState(true);

  const handleRemoveClick = (date) => {
    const list = [...dates];
    const ar = list.filter((item) => !(item === date));

    setDates(ar);

    const scheduleList = [...newSchedule];
    const ar2 = scheduleList.filter((item) => !(item === date));
    setNewSchedule(ar2);

    setCreateForm(false);
  };

  const handleNewSchedule = (index) => {
    setSchedule(dates[index]);
    setCreateForm(true);
    getDateWiseSchedule(dates[index]);
  };

  const getDateWiseSchedule = (dates) => {
    var date = dates.year + "-" + dates.month?.number + "-" + dates.day;
    let selectedDate = moment(date).format("YYYY-MM-DD");

    axios.get(`/api/admin/schedule/${selectedDate}`).then((res) => {
      if (res.status === 200) {
        setSelectedSchedule(res.data.schedule);
        // setDates(res.data.schedule)
      }
    });
  };

  function handleCheck(event, day) {
    setSelectElement(day);
    setPending(event);
  }

  return (
    <>
      <AllDataHeader
        title=" Make SuperStar Schedule"
        count="Zero"
        icon="true"
        iconP="fa-solid fa-calendar-days"
      />

      <div className="eventDatePicker d-flex justify-content-center mt-4">
        <Calendar
          value={dates}
          onChange={setDates}
          format="YYYY-MM-DD"
          multiple
          sort
          calendarPosition="bottom-center"
        />
      </div>

      <div className="row mb-4 mt-5">
        {dates.map((date, i) => {
          return (
            <div className=" col-md-4 col-lg-2 mb-3" key={i}>
              <div
                className={`head-line  d-flex justify-content-between  text-light card-text lead p-2 ${
                  selectElement === date.day ? "SetCreate" : "NewCreate"
                } `}
              >
                <div className="div text-black fw-bold">
                  {date.day} {date.month.shortName}, {date.year}{" "}
                </div>{" "}
                <div className="d-flex justify-content-center align-items-center m-0">
                  <button
                    className="btn NewBtn mb-2 me-2"
                    onClick={() => handleNewSchedule(i)}
                    type="button"
                    title="New Schedule Create"
                  >
                    <i class="fa-solid fa-calendar-plus text-light"></i>
                  </button>
                  <button
                    title="Remove Schedule "
                    className="btn RemoveBtn mb-2 me-2"
                    onClick={() => handleRemoveClick(date)}
                    type="button"
                  >
                    <i className="fas fa-times text-light"></i>
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {createForm === true ? (
        <>
          {" "}
          <NewSchedule
            schedule={schedule}
            selectedSchedule={selectedSchedule}
            onClick={handleCheck}
          />
        </>
      ) : null}
    </>
  );
};

export default EventScheduleDatePick;
